import IFormModel from "@/models/IFormModel";
import {ValidationRule} from "@/declarations/ValidationRule";
import PlanningEntryRules from "@/models/planningEntry/PlanningEntryRules";

export default class PlanningEntryCreate implements IFormModel {

	public orderId: string | null = null;
	public date: string | null = null;
	public userId: string | null = null;
	public notes: string | null = null;

	public reset(): void {
		this.orderId = null;
		this.date = null;
		this.userId = null;
		this.notes = null;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'orderId':
				return PlanningEntryRules.orderIdRules;
			case 'date':
				return PlanningEntryRules.dateRules;
			default:
				return [];
		}
	}

}
